import { Component, OnInit } from '@angular/core';
import { E5coreUiWorkCasenotesBaseComponent } from './e5core-ui-work-casenotes-base';

@Component({
  selector: 'e5core-ui-work-casenotes-box',
  templateUrl: './e5core-ui-work-casenotes-box.component.html',
  styleUrls: ['./e5core-ui-work-casenotes-box.component.css']
})
export class E5coreUiWorkCasenotesBoxComponent extends E5coreUiWorkCasenotesBaseComponent {

}
